import FilterJsonMiddleware from '../helpers/filterJsonMiddleware';

export const menuItems = new FilterJsonMiddleware([

    //#region Standard Dashboard Routes.
    {
        id: 1,
        isLayout: true
    },
    {
        id: 2,
        label: "menuitems.statistics.text",
        icon: "bx bx-bar-chart-alt",
        link: "/statistics"
    },
    //#region Custom Dashboard Routes.

    //write your menue items hear.
    {
        id: 3,
        label: "menuitems.application.text",
        icon: "bx-file",
        link: "/application",
        permission:{
            filter: 'any',
            values: ['show_volunteer_application', 'show_details_volunteer_application']
        },
    },

    {
        id: 4,
        label: "menuitems.activities.text",
        icon: "bx-file",
        link: "/activities",
        permission:{
            filter: 'any',
            values: ['show_volunteer_activities', 'show_details_volunteer_activities']
        },
    },

    {
        id: 5,
        label: "menuitems.workTeam.text",
        icon: "bx-file",
        link: "/workTeam",
        permission:{
            filter: 'any',
            values: ['show_volunteer_work_team', 'show_details_volunteer_work_team']
        },
    },


    {
        id: 12,
        label: "menuitems.exportData.text",
        icon: "bx-file",
        link: "/exportData",
        permission:{
            filter: 'any',
            values: ['export_to_excel_volunteer_application', 'export_to_excel_volunteer_activities', 'export_to_excel_volunteer_work_team']
        },
    },
    //#endregion

    {
        id: 13,
        label: "menuitems.admins.text",
        icon: "bxs-user-detail",
        link: "/admins",
        permission:{
            filter: 'any',
            values: ['show_admin', 'add_admin', 'edit_admin', 'delete_admin']
        },
    },
    {
        id: 14,
        label: "menuitems.account.text",
        icon: "bxs-lock",
        link: "/account"
    },
    {
        id: 15,
        label: "menuitems.log.text",
        icon: "bx-group",
        link: "/admins/log_activity",
        permission:{
            filter: 'any',
            values: ['show_logs']
        },
    },
    //#endregion
]).data

